import script from "./FirstScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstScreen.vue?vue&type=script&setup=true&lang=js"

import "./FirstScreen.vue?vue&type=style&index=0&id=fd4bba90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd4bba90"]])

export default __exports__